module.exports = __webpack_public_path__ + "img/LUCKY_LIONS_02.e0001013.jpg";